<ion-content class="garment-employee-lookup">
  <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Replace Work Order'" [breadcrumbs]="breadcrumbs"></app-header>
  <div class="content" style="padding-top:120px">

    <div>
        <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
         
   <div class="ion-padding table-container">
          <app-replace-work-order-item-table [mode]="'gl'"  [rows]="woGarmentList" [currentRoute]="currentRoute"  >
          </app-replace-work-order-item-table>
        </div>
 
 
    </div>
  </div>
</ion-content>
